import { ThemeConfig } from 'antd'
import PALLETTE from './pallette.module.scss'
const controlHeight = 50

export const defaultTheme: ThemeConfig = {
  token: {
    colorPrimary: PALLETTE.primaryColor,
    controlHeight: 40,
    fontSize: 16,
    borderRadius: 8,
    fontFamily: 'Roboto',
    colorBgContainer: PALLETTE.secondaryBackground,
    colorBorder: PALLETTE.secondaryBackground,
    colorText: '#ffffff',
  },
  components: {
    Button: {
      controlHeight,
      colorText: '#000000',
      colorPrimaryText: '#000000',
    },
    Select: {
      controlHeight,
    },
    DatePicker: {
      controlHeight,
    },
    Input: {
      controlHeight,
    },
    InputNumber: {
      controlHeight,
    },
    Layout: {
      headerBg: PALLETTE.primaryColor,
      headerColor: 'white',
    },
  },
}
